import { useEffect, useState } from 'react';

/**
 * 모바일 뷰포트 (`< 768px`, Tailwind `md` 미만) 여부.
 * 사이드바 overlay 모드 / 모달 풀스크린 등 모바일 전용 UX 분기에 사용.
 *
 * SSR / pre-hydrate 에선 false 반환 (데스크탑 default) — hydrate 후 첫 effect 에서 보정.
 */
const MOBILE_QUERY = '(max-width: 767px)';

function readInitial(): boolean {
  if (typeof window === 'undefined') return false;
  if (typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_QUERY).matches;
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState<boolean>(readInitial);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(MOBILE_QUERY);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    // 초기 상태 동기화 (state 가 readInitial 과 다를 수 있음 — devtools 강제 변경 등).
    setIsMobile(mql.matches);
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handler);
      return () => mql.removeEventListener('change', handler);
    }
    // Safari < 14 호환.
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, []);

  return isMobile;
}
